import apiClient from "./client";
import {
  User,
  UserProfile,
  UpdateProfileData,
  UserAuthMethodsResponse,
  DashboardStats,
} from "../types";

// Get current user
export const getCurrentUser = async (): Promise<User> => {
  const response = await apiClient.get<User>("/users/me");
  return response.data;
};

// Get user auth methods
export const getAuthMethods = async (): Promise<UserAuthMethodsResponse> => {
  const response = await apiClient.get<UserAuthMethodsResponse>(
    "/users/me/auth-methods"
  );
  return response.data;
};

// Update user profile
export const updateProfile = async (data: UpdateProfileData): Promise<User> => {
  const response = await apiClient.patch<User>("/users/me", data);
  return response.data;
};

// Get dashboard stats
export const getDashboardStats = async (): Promise<DashboardStats> => {
  const response = await apiClient.get<DashboardStats>(
    "/users/stats/dashboard"
  );
  return response.data;
};

// Get user by ID
export const getUserById = async (userId: string): Promise<UserProfile> => {
  const response = await apiClient.get<UserProfile>(`/users/${userId}`);
  return response.data;
};

// Change password
export interface ChangePasswordData {
  current_password: string;
  new_password: string;
}

export interface ChangePasswordResponse {
  success: boolean;
  message: string;
}

export const changePassword = async (data: ChangePasswordData): Promise<ChangePasswordResponse> => {
  const response = await apiClient.post<ChangePasswordResponse>("/users/me/change-password", data);
  return response.data;
};

// Upload avatar
export const uploadAvatar = async (file: File): Promise<User> => {
  const formData = new FormData();
  formData.append("file", file);
  
  const response = await apiClient.post<User>("/users/me/avatar", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
